var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './Forms.module.scss';
import { Button } from 'antd';
import { useComponentLocale } from '../../hooks/useComponentLocale';
import { history } from '../../_history';
var WelcomeForm = function (_a) {
    var setIsSignUpFinishPage = _a.setIsSignUpFinishPage, setIsLoginPage = _a.setIsLoginPage, isUserConfirmed = _a.isUserConfirmed;
    var getLocale = useComponentLocale();
    var thanksLocale = getLocale({ component: 'auth_page', section: 'thanks' });
    var welcomeTextLocale = getLocale({ component: 'auth_page', section: 'welcome_text' });
    var emailActivatedLocale = getLocale({ component: 'auth_page', section: 'email_activated' });
    var loginLocale = getLocale({ component: 'common_buttons', section: 'login' });
    var closeWelcomeForm = function () {
        setIsSignUpFinishPage(false);
        setIsLoginPage(true);
        isUserConfirmed && history.push('/');
    };
    return (_jsxs("div", __assign({ className: styles.welcomeFormContainer }, { children: [_jsx("span", __assign({ className: styles.cardTitle }, { children: thanksLocale })), _jsx("span", __assign({ className: styles.resetInstructions }, { children: isUserConfirmed ? emailActivatedLocale : welcomeTextLocale })), _jsx(Button, __assign({ type: 'primary', size: 'large', className: styles.resetFinalBtn, onClick: closeWelcomeForm }, { children: loginLocale }))] })));
};
export default WelcomeForm;
